export default __webpack_public_path__ + "static/ourMission-abc7a3b55dcaf313b686756f3f761ced.png";